import styled, { css } from "styled-components";
import { Colors, FInter, FlexBox, Fonts, MagicBox } from "@brg/ui";
import { TagItemViewTextWrapper } from "../../../core/components/bTag/styles";
import { SearchResultsRoot } from "./SearchResults";
import { LayoutConst } from "core/modules";
import { LevelOneTitle } from "./CategoryHeader";

export const TagItemWrapper = styled(FlexBox)<{ selected?: boolean, disableHover?: boolean, isActive?: boolean }>`
    cursor: pointer;
    padding: 16px 10.5px 16px;
    position: relative;,
    width: 100%;
    margin-left: -10px;

    @media (max-width: ${LayoutConst.screen.md}px) {
        width: 100vw;
    }

    ${TagItemViewTextWrapper} {
        margin-bottom: 0 !important;
    }

    :after {
        content: ' ';
        position: absolute;
        bottom: 0;
        width: calc(100% + 20px);
        height: 1px;
        background: ${({theme}) => theme.tags.modal.simpleTag.bottomLine};
    }

    ${({disableHover, selected, theme}) => disableHover && !selected ? css`
        background-color: transparent !important;

        &:hover {
            background-color: transparent !important;
        }
    ` : css`
        background-color: ${selected ? theme.tags.selectedCategory : 'none'} !important;

        &:hover {
            background-color: ${theme.tags.selectedCategory} !important;
        }
    `}

`

export const TagsSearchScrollWrapper = styled(FlexBox)`
    height: 100%;
    overflow-y: overlay;
    display: block;
    padding-bottom: 50px !important;

    &::-webkit-scrollbar {
        height: 1px;
        width: 2px;
    }

    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: ${({theme}) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
    }
`;

export const TagsSearchModalContainer = styled(FlexBox).attrs({
    className: "--container",
})<{ isMobileMenu?: boolean }>`
    flex-direction: column;
    width: 1152px;
    margin: 107px auto 0;
}

@media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 940px;
}

@media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    margin-top: 6px;
    padding: 0 10px;

    ${({isMobileMenu}) => isMobileMenu ? css`
        padding: 0 24px;
    ` : null};
}

@media (max-width: ${LayoutConst.screen.s}px) {
    ${({isMobileMenu}) => isMobileMenu ? css`
        padding: 0 16px;
    ` : null};
}
`;

export const TagsSearchInput = styled.input.attrs({className: "--input"})<{
    isMobileInput?: boolean;
}>`
    ${Fonts.Inter.text};
    color: ${(p) => p.theme.tagSearch.inputColor};
    width: 100%;
    height: 32px;
    background: ${(p) =>
            p?.isMobileInput ? p?.theme.tagSearch.background : "transparent"};
    border: none;
    border-bottom: 1px solid ${(p) => p.theme.tagSearch.inputColor};
    outline: none;

    ::placeholder {
        color: ${(p) => p.theme.mainSearchBar.input.placeholder.color};
        font-size: 13px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        padding: 0;
        border-bottom: none;
        order: -1;
        height: initial;

        ::placeholder {
            color: ${(p) => p.theme.mainSearchBar.input.placeholder.color};
            font-size: 13px;
            line-height: 18px;
        }
    }
`;

export const TagsSearchInputWrapper = styled(FlexBox)<{ isMobileMenu?: boolean }>`
    border-bottom: 1px solid ${({theme}) => theme.tags.modal.search.border};
    place-items: baseline;
    margin-top: ${({isMobileMenu}) => isMobileMenu ? '18px' : '16px'};

    svg {
        display: block;
        flex-shrink: 0;
    }

    input {
        border-bottom: none;
        font-size: 30px;

        &::placeholder {
            color: ${(p) => p.theme.mainSearchBar.input.placeholder.color};
            font-size: 13px;
            font-weight: 400;
        }
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        flex-flow: row-reverse;
        border-radius: 3px;
        padding: ${({isMobileMenu}) => isMobileMenu ? '11px 16px 11px 0' : '13px 16px 11px 16px'};
        background: ${({isMobileMenu, theme}) => isMobileMenu ? theme.navigationBar?.mobileMenu?.search?.bg : theme.tags.modal.search.bg};
        align-items: center;
        border: none;

        input {
            font-size: 13px;
            line-height: 16px;

            :first-child {
                margin-left: 0;
            }
        }

        width: calc(100%);
        svg {
            width: 19px !important;

            * {
                fill: ${(p) => p.theme.navigationBar.search.svg} !important;
            }
        }
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        height: 40px;
        margin-top: ${({isMobileMenu}) => isMobileMenu ? '10px' : '16px'};

        ${({isMobileMenu}) => isMobileMenu ? css`
            width: calc(100%);
            height: 40px;

            svg {

                * {
                    fill: ${(p) => p.theme.navigationBar.search.svg} !important;
                }
            }

        ` : null};
    }
`;



export const SearchIconWrapper = styled.div<{isMobileMenu?: boolean}>`
    width:  ${({isMobileMenu}) => isMobileMenu ? '47px' : '16px'};
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: ${({isMobileMenu}) => isMobileMenu ? '0' : '12px'};
`

export const TagsSearchTitle = styled(FInter.SectionTitleSubtitleBoldDiv)`
    font-size: 43px;
    line-height: 51px;
    letter-spacing: -0.02em;
    display: flex;
    justify-content: space-between;
    align-items: center;

    svg {
        width: 16px;
    }

    ${LevelOneTitle} {
        color: ${({theme}) => theme.tagSearch.titleColor};
    }

    ${MagicBox} {
        margin-left: 3px;
    }

    :first-letter {
        text-transform: capitalize;

        @media (max-width: ${LayoutConst.screen.m}px) {
            text-transform: none;
        }
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 28px;
        font-weight: 600;
        line-height: 34px;
    }
`;

export const TagsSelectedTitle = styled(FInter.Text)`
    color: ${Colors.geoWhite61};
    height: 34px;
    font-size: 17px;
    letter-spacing: -0.02em;

    @media (max-width: ${LayoutConst.screen.m}px) {
        height: initial;
        font-size: 13px;
        line-height: 16px;
        margin-bottom: 16px;
    }
`;

export const TagsSearchSelection = styled.div.attrs({
    className: "--selection",
})`
    span {
        font-size: 11px;
        line-height: 13px;
        margin-bottom: 0;
        display: block;
    }

    > * {
        margin-right: 10px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        display: flex;
        flex-wrap: wrap;
    }
`;

export const TagsSearchResults = styled(FlexBox).attrs({
    className: "--results",
})`
    height: auto;
    overflow-x: hidden;
    position: relative;
    margin-top: 12px;

    @media (max-width: 720px) {
        // padding-bottom: 100px;
        height: auto; /* поменяла здесь и сверху высоту и оверлфлоу для скролла всего окна */
    }

    & > div > div {
        border-bottom: 1px solid ${({ theme }) => theme.mobileLinks.borderColor}; 
    } 
`;

export const TagsSearchResultsTitle = styled(FInter.TextBoldMagic).attrs({
    className: "--title",
})`
    color: ${(p) => p.theme.tagSearch.subtitleColor};
    opacity: 1;
    position: relative;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 25px; /* 125% */
    letter-spacing: -0.4px;
    display: inline-flex;
    transition: 0.5s color, opacity 0.2s;
    place-items: center;
    margin-right: -0.2px;

    svg path {
        transition: 0.5s fill;
    }

    :hover {
        color: ${(p) => p.theme.tagSearch.subtitleColorHover};
        transition: 0.5s color;

        svg path {
            fill: ${(p) => p.theme.tagSearch.subtitleColorHover};
            transition: 0.5s fill;
        }
    }

    user-select: none;

    @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 17px;
        line-height: 22px;
        margin-bottom: 0;
        font-weight: 600;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 17px;
        line-height: 22px;
        font-weight: 600;
    }
`;

export const InputSmallCaption = styled(FlexBox)`
    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 13px;
    color: #ABAEAF;
    padding-top: 8px;
`;

export const HeaderTagRoot = styled(FlexBox)`
    ${TagsSearchResultsTitle} {
        * {
            color: ${({theme}) => theme.tags.modal.header.color} !important;
        }
    }

    margin-bottom: 8px;
`

export const TagsSearchModalWrapper = styled.div.attrs({
    className: "tags-search-modal",
})<{ isMobileMenu?: boolean }>`
    user-select: none;
    height: 100%;
    width: 100%;

    ${HeaderTagRoot} {
        height: 38.5px;
        @media (max-width: ${LayoutConst.screen.s - 1}px) {
            margin-bottom: 6px;
            margin-top: 10px;
        }

        ${LevelOneTitle} {
            color: ${({theme}) => theme.tags.modal.header.colorLvlOne} !important;
        }
    }

    ${SearchResultsRoot} {
        margin-top: ${({isMobileMenu}) => isMobileMenu ? '0' : '24px'};

    }

    .__react_component_tooltip {
        opacity: 1 !important;
        padding: 2px 8px 4px;
    }

    ${TagItemWrapper} {
        padding: 14px 40px 14px 10.5px;

        @media (max-width: ${LayoutConst.screen.s}px) {
            padding: 14px 24px 14px 10.5px;
        }

        svg {
            width: 24.4px;

            @media (max-width: ${LayoutConst.screen.s}px) {
                width: 16px;
                height: 16px;
            }
        }

        ${TagItemViewTextWrapper} {
            padding: 5px 16px;
        }
    }
`;
import styled, { css } from "styled-components";
import { Colors, FInter, FlexBox, Fonts, MagicBox } from "@brg/ui";
import { TagItemViewTextWrapper } from "../../../core/components/bTag/styles";
import { SearchResultsRoot } from "./SearchResults";
import { LayoutConst } from "core/modules";
import { LevelOneTitle } from "./CategoryHeader";

export const TagItemWrapper = styled(FlexBox)<{ selected?: boolean, disableHover?: boolean, isActive?: boolean }>`
    cursor: pointer;
    padding: 16px 10.5px 16px;
    position: relative;,
    width: 100%;
    margin-left: -10px;

    @media (max-width: ${LayoutConst.screen.md}px) {
        width: 100vw;
    }

    ${TagItemViewTextWrapper} {
        margin-bottom: 0 !important;
    }

    :after {
        content: ' ';
        position: absolute;
        bottom: 0;
        width: calc(100% + 20px);
        height: 1px;
        background: ${({theme}) => theme.tags.modal.simpleTag.bottomLine};
    }

    ${({disableHover, selected, theme}) => disableHover && !selected ? css`
        background-color: transparent !important;

        &:hover {
            background-color: transparent !important;
        }
    ` : css`
        background-color: ${selected ? theme.tags.selectedCategory : 'none'} !important;

        &:hover {
            background-color: ${theme.tags.selectedCategory} !important;
        }
    `}

`

export const TagsSearchScrollWrapper = styled(FlexBox)`
    height: 100%;
    overflow-y: overlay;
    display: block;
    padding-bottom: 50px !important;

    &::-webkit-scrollbar {
        height: 1px;
        width: 2px;
    }

    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: ${({theme}) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
    }
`;

export const TagsSearchModalContainer = styled(FlexBox).attrs({
    className: "--container",
})<{ isMobileMenu?: boolean }>`
    flex-direction: column;
    width: 1152px;
    margin: 107px auto 0;
}

@media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 940px;
}

@media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    margin-top: 6px;
    padding: 0 10px;

    ${({isMobileMenu}) => isMobileMenu ? css`
        padding: 0 24px;
    ` : null};
}

@media (max-width: ${LayoutConst.screen.s}px) {
    ${({isMobileMenu}) => isMobileMenu ? css`
        padding: 0 16px;
    ` : null};
}
`;

export const TagsSearchInput = styled.input.attrs({className: "--input"})<{
    isMobileInput?: boolean;
}>`
    ${Fonts.Inter.text};
    color: ${(p) => p.theme.tagSearch.inputColor};
    width: 100%;
    height: 32px;
    background: ${(p) =>
            p?.isMobileInput ? p?.theme.tagSearch.background : "transparent"};
    border: none;
    border-bottom: 1px solid ${(p) => p.theme.tagSearch.inputColor};
    outline: none;

    ::placeholder {
        color: ${(p) => p.theme.mainSearchBar.input.placeholder.color};
        font-size: 13px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        padding: 0;
        border-bottom: none;
        order: -1;
        height: initial;

        ::placeholder {
            color: ${(p) => p.theme.mainSearchBar.input.placeholder.color};
            font-size: 13px;
            line-height: 18px;
        }
    }
`;

export const TagsSearchInputWrapper = styled(FlexBox)<{ isMobileMenu?: boolean }>`
    border-bottom: 1px solid ${({theme}) => theme.tags.modal.search.border};
    place-items: baseline;
    margin-top: ${({isMobileMenu}) => isMobileMenu ? '18px' : '16px'};

    svg {
        display: block;
        flex-shrink: 0;
    }

    input {
        border-bottom: none;
        font-size: 30px;

        &::placeholder {
            color: ${(p) => p.theme.mainSearchBar.input.placeholder.color};
            font-size: 13px;
            font-weight: 400;
        }
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        flex-flow: row-reverse;
        border-radius: 3px;
        padding: ${({isMobileMenu}) => isMobileMenu ? '11px 16px 11px 0' : '13px 16px 11px 16px'};
        background: ${({isMobileMenu, theme}) => isMobileMenu ? theme.navigationBar?.mobileMenu?.search?.bg : theme.tags.modal.search.bg};
        align-items: center;
        border: none;

        input {
            font-size: 13px;
            line-height: 16px;

            :first-child {
                margin-left: 0;
            }
        }

        width: calc(100%);
        svg {
            width: 19px !important;

            * {
                fill: ${(p) => p.theme.navigationBar.search.svg} !important;
            }
        }
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        height: 40px;
        margin-top: ${({isMobileMenu}) => isMobileMenu ? '10px' : '16px'};

        ${({isMobileMenu}) => isMobileMenu ? css`
            width: calc(100%);
            height: 40px;

            svg {

                * {
                    fill: ${(p) => p.theme.navigationBar.search.svg} !important;
                }
            }

        ` : null};
    }
`;



export const SearchIconWrapper = styled.div<{isMobileMenu?: boolean}>`
    width:  ${({isMobileMenu}) => isMobileMenu ? '47px' : '16px'};
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: ${({isMobileMenu}) => isMobileMenu ? '0' : '12px'};
`

export const TagsSearchTitle = styled(FInter.SectionTitleSubtitleBoldDiv)`
    font-size: 43px;
    line-height: 51px;
    letter-spacing: -0.02em;
    display: flex;
    justify-content: space-between;
    align-items: center;

    svg {
        width: 16px;
    }

    ${LevelOneTitle} {
        color: ${({theme}) => theme.tagSearch.titleColor};
    }

    ${MagicBox} {
        margin-left: 3px;
    }

    :first-letter {
        text-transform: capitalize;

        @media (max-width: ${LayoutConst.screen.m}px) {
            text-transform: none;
        }
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 28px;
        font-weight: 600;
        line-height: 34px;
    }
`;

export const TagsSelectedTitle = styled(FInter.Text)`
    color: ${Colors.geoWhite61};
    height: 34px;
    font-size: 17px;
    letter-spacing: -0.02em;

    @media (max-width: ${LayoutConst.screen.m}px) {
        height: initial;
        font-size: 13px;
        line-height: 16px;
        margin-bottom: 16px;
    }
`;

export const TagsSearchSelection = styled.div.attrs({
    className: "--selection",
})`
    span {
        font-size: 11px;
        line-height: 13px;
        margin-bottom: 0;
        display: block;
    }

    > * {
        margin-right: 10px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        display: flex;
        flex-wrap: wrap;
    }
`;

export const TagsSearchResults = styled(FlexBox).attrs({
    className: "--results",
})`
    height: auto;
    overflow-x: hidden;
    position: relative;
    margin-top: 12px;

    @media (max-width: 720px) {
        // padding-bottom: 100px;
        height: auto; /* поменяла здесь и сверху высоту и оверлфлоу для скролла всего окна */
    }

    & > div > div {
        border-bottom: 1px solid ${({ theme }) => theme.mobileLinks.borderColor}; 
    } 
`;

export const TagsSearchResultsTitle = styled(FInter.TextBoldMagic).attrs({
    className: "--title",
})`
    color: ${(p) => p.theme.tagSearch.subtitleColor};
    opacity: 1;
    position: relative;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 25px; /* 125% */
    letter-spacing: -0.4px;
    display: inline-flex;
    transition: 0.5s color, opacity 0.2s;
    place-items: center;
    margin-right: -0.2px;

    svg path {
        transition: 0.5s fill;
    }

    :hover {
        color: ${(p) => p.theme.tagSearch.subtitleColorHover};
        transition: 0.5s color;

        svg path {
            fill: ${(p) => p.theme.tagSearch.subtitleColorHover};
            transition: 0.5s fill;
        }
    }

    user-select: none;

    @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 17px;
        line-height: 22px;
        margin-bottom: 0;
        font-weight: 600;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 17px;
        line-height: 22px;
        font-weight: 600;
    }
`;

export const InputSmallCaption = styled(FlexBox)`
    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 13px;
    color: #ABAEAF;
    padding-top: 8px;
`;

export const HeaderTagRoot = styled(FlexBox)`
    ${TagsSearchResultsTitle} {
        * {
            color: ${({theme}) => theme.tags.modal.header.color} !important;
        }
    }

    margin-bottom: 8px;
`

export const TagsSearchModalWrapper = styled.div.attrs({
    className: "tags-search-modal",
})<{ isMobileMenu?: boolean }>`
    user-select: none;
    height: 100%;
    width: 100%;

    ${HeaderTagRoot} {
        height: 38.5px;
        @media (max-width: ${LayoutConst.screen.s - 1}px) {
            margin-bottom: 6px;
            margin-top: 10px;
        }

        ${LevelOneTitle} {
            color: ${({theme}) => theme.tags.modal.header.colorLvlOne} !important;
        }
    }

    ${SearchResultsRoot} {
        margin-top: ${({isMobileMenu}) => isMobileMenu ? '0' : '24px'};

    }

    .__react_component_tooltip {
        opacity: 1 !important;
        padding: 2px 8px 4px;
    }

    ${TagItemWrapper} {
        padding: 14px 40px 14px 10.5px;

        @media (max-width: ${LayoutConst.screen.s}px) {
            padding: 14px 24px 14px 10.5px;
        }

        svg {
            width: 24.4px;

            @media (max-width: ${LayoutConst.screen.s}px) {
                width: 16px;
                height: 16px;
            }
        }

        ${TagItemViewTextWrapper} {
            padding: 5px 16px;
        }
    }
`;
